<template>
  <div>
    <div class="fullscreen-modal__content">
      <page>
        <page-title v-t="'c.mailingOverlay.stepSummary.title'"/>

        <div class="stats">
          <div class="stats__item">
            {{ selectedContent.length }}
            <span>{{ $tc('c.mailingOverlay.stepSummary.stats.articles', selectedContent.length) }}</span>
          </div>
          <div
            v-if="groupByTags"
            class="stats__item"
          >
            {{ selectedTags.length }}
            <span>{{ $tc('c.mailingOverlay.stepSummary.stats.groups', selectedTags.length) }}</span>
          </div>
          <div class="stats__item">
            {{ selectedRecipients.length }}
            <span>{{ $tc('c.mailingOverlay.stepSummary.stats.recipients', selectedRecipients.length) }}</span>
          </div>
        </div>

        <form-field-set>
          <tags-input
            v-model="previewRecipients"
            :taggable="true"
            :options="[]"
            :label-visible="true"
            :full-width="true"
            :label="$t('c.mailingOverlay.stepSummary.previewRecipients')"
            direction="vertical"
            name="previewRecipients"
            @tag="addPreviewRecipient"
          />
        </form-field-set>
      </page>
    </div>
    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.mailingOverlay.stepSummary.btnNext'"
              @click="sendMail"
            />
            <button-input
              v-t="'c.mailingOverlay.stepSummary.btnPreview'"
              :is-disabled="!hasPreviewRecipients"
              :outline="true"
              @click="sendPreview"
            />
          </div>

          <div class="col-xs-6 col-lg-4 push-lg-2 text-right">
            <button-input
              v-t="'c.mailingOverlay.stepRecipients.btnBack'"
              color="grey"
              @click="prevStep"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import isBlank from 'is-blank'
import FormMixin from '@/mixins/forms/Form'
import PageMixin from '@/mixins/pages/Page'
import NotificationsMixin from '@/mixins/notifications/notifications'
import { isEmail } from '@/support'

export default {
  mixins: [FormMixin, PageMixin, NotificationsMixin],

  computed: {
    ...mapState ({
      currentUser: state => state.currentUser.currentUser,
      groupByTags: state => state.mailing.entry.groupByTags,
      mailing: state => state.mailing.entry
    }),
    ...mapGetters ({
      selectedTags: 'mailing/entry/selectedTags',
      selectedContent: 'mailing/entry/selectedContent',
      selectedRecipients: 'mailing/entry/selectedRecipients'
    }),
    previewRecipients: {
      get () { return this.$store.state.mailing.entry.previewRecipients },
      set (value) { this.$store.dispatch('mailing/entry/setPreviewRecipients', value) }
    },
    hasPreviewRecipients() {
      return this.previewRecipients.length > 0
    }
  },

  methods: {
    ...mapActions({
      publish: 'mailing/entry/publishMailing',
      prevStep: 'mailing/step/prev',
      nextStep: 'mailing/step/next'
    }),
    sendMail () {
      this.publish({perform: 'publish'})
        .then(() => this.nextStep())
    },
    sendPreview () {
      this.publish({perform: 'preview'})
        .then(() => this.successNotification(this.$tc('c.mailingOverlay.stepSummary.notification')))
    },
    addPreviewRecipient (recipients) {
      const recipient = recipients.slice(-1)[0]

      if (isEmail(recipient.value)) {
        this.$store.dispatch('mailing/entry/setPreviewRecipients', recipients)
      }
    }
  },

  created() {
    this.addPreviewRecipient([{
      label: this.currentUser.email,
      value: this.currentUser.email
    }])
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

.stats
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: center
  margin-bottom: rem-calc(30)
  margin-left: -10px;
  margin-right: -10px;

  &__item
    flex: 1;
    +font-size(48, 56)
    font-weight: 700
    background: #f0f3f5
    text-align: center
    padding: rem-calc(40 0)
    margin: rem-calc(10)

    span
      +font-size(14, 20)
      display: block
      color: #878c96
      font-weight: 400
</style>



// WEBPACK FOOTER //
// src/components/mailings/steps/Summary.vue